import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyCustomerKey,
  ShopifyCustomerMergeableKey,
  ShopifyCustomerMergeableToCustomerKey,
  ShopifyCustomerMergeableToShopKey,
  ShopifyShopKey,
} from "./keys";
import type { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyCustomerMergeableKey,
  "2023-07": {
    name: "Shopify Customer Mergeable",
    fields: [
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "id" } },
      },
      {
        name: "Is Mergeable",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "isMergeable" } },
      },
      {
        name: "Reason",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "reason" } },
      },
      {
        name: "Error Fields",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "errorFields" } },
      },
      {
        name: "Merge In Progress",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "mergeInProgress" } },
      },
      {
        name: "Shopify Customer",
        fieldType: FieldType.BelongsTo,
        key: ShopifyCustomerMergeableToCustomerKey,
        configuration: {
          relatedModelKey: ShopifyCustomerKey,
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyCustomerMergeableToShopKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "shop_id" } },
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: { type: "rest_list", resource: "customer" },
  },
  "2025-04": {
    fields: [
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "id", graphQLFieldKey: "id" } },
      },
      {
        name: "Is Mergeable",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "isMergeable", graphQLFieldKey: "isMergeable" } },
      },
      {
        name: "Reason",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "reason", graphQLFieldKey: "reason" } },
      },
      {
        name: "Error Fields",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "errorFields", graphQLFieldKey: "errorFields" } },
      },
      {
        name: "Merge In Progress",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "mergeInProgress", graphQLFieldKey: "mergeInProgress" } },
      },
      {
        name: "Shopify Customer",
        fieldType: FieldType.BelongsTo,
        key: ShopifyCustomerMergeableToCustomerKey,
        configuration: {
          relatedModelKey: ShopifyCustomerKey,
        },
      },
    ],
    // Synced as part of ShopifyCustomer
    syncConfig: { type: "inherit" } as const,
  },
};

export const ShopifyCustomerMergeable = ({
  apiVersion,
  frameworkVersionConstraint,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint: string;
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint);
